import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SystemApiClient } from '../clients/system-api/SystemApiClientp';
import { AddScheduleData, AddWorkingHoursDailyConfigs, AdministrationResultStatus, DailyAvailabilityArgs, DateTimeAvailabilityDataDictionaryAdministrationResult, PeriodicScheduleEntriesResultDataAdministrationResult, PeriodicScheduleGroupsAvailabilityArgs, ScheduleDataAdministrationResult, ScheduleDataListAdministrationResult, UpdateScheduleData } from '../clients/system-api/SystemApiClient';
@Injectable({
  providedIn: 'root'
})
export class ScheduleService {
  constructor(private systemApiClient: SystemApiClient) { }

  retrieveAllSchedules(employeeProfileId: number | undefined = undefined): Observable<ScheduleDataListAdministrationResult>  {
    return this.systemApiClient.retrieveAllSchedules(employeeProfileId);
  }
  
  retrieveAllActiveUnpassedEmployeeSchedulesBasic(employeeProfileId: number | undefined = undefined): Observable<ScheduleDataListAdministrationResult>  {
    return this.systemApiClient.retrieveAllActiveUnpassedEmployeeSchedulesBasic(employeeProfileId);
  }

  retrieveAvailability(body: DailyAvailabilityArgs | undefined): Observable<DateTimeAvailabilityDataDictionaryAdministrationResult> {
    return this.systemApiClient.retrieveAvailability(body);
  }
  
  retrieveScheduleById(scheduleId: number | undefined): Observable<ScheduleDataAdministrationResult> {
    return this.systemApiClient.retrieveScheduleById(scheduleId);
  }

  retrieveSchedulesByEmployeeId(employeeId: number | undefined): Observable<ScheduleDataListAdministrationResult> {
    return this.systemApiClient.retrieveSchedulesByEmployeeId(employeeId);
  }

  addSchedule(body: AddScheduleData[] | undefined): Observable<AdministrationResultStatus> {
    return this.systemApiClient.addSchedule(body!);
  }

  updateScheduleRange(body: UpdateScheduleData | undefined): Observable<AdministrationResultStatus> {
    return this.systemApiClient.updateScheduleRange(body!);
  }

  deactivateSchedule(scheduleId: number | undefined): Observable<AdministrationResultStatus> {
    return this.systemApiClient.deactivateSchedule(scheduleId);
  }

  deactivateSchedulesByEmployeeId(employeeId: number | undefined): Observable<AdministrationResultStatus> {
    return this.systemApiClient.deactivateSchedulesByEmployeeId(employeeId);
  }

  updateNegatedSchedulesByWorkingHoursDailyConfigsChange(body: AddWorkingHoursDailyConfigs | undefined): Observable<ScheduleDataListAdministrationResult>{
    return this.systemApiClient.updateNegatedSchedulesByWorkingHoursDailyConfigsChange(body);
  }

  retrievePeriodicScheduleEntries(body: PeriodicScheduleGroupsAvailabilityArgs | undefined): Observable<PeriodicScheduleEntriesResultDataAdministrationResult>{
    return this.systemApiClient.retrievePeriodicScheduleEntries(body);
  }
}